/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  ListItemText,
} from '@mui/material'
import { useFormik } from 'formik'
import { Box } from '@mui/system'
import moment from 'moment'
import * as Yup from 'yup'

// @assets
import { DialogFilterPayroll } from '../../../assets/css/payroll-style'

// @material-ui
import {
  TextField,
  Button,
  Checkbox,
  Dialog,
  Grid,
  MenuItem,
  Select,
  Typography
} from "../../../components/shared/MaterialUI";

// @helpers
import {
  convertNameStateStatus,
  MenuItemProps,
  stateStatusList,
} from '../../../helpers/FunctionsUtils'
import AppHelper from '../../../helpers/AppHelper'
import DateFilter from './components/DateFilter'

// @services
import PayrollService from '../../../services/newApi/PayrollService'

import { useUI } from '../../../app/context/ui'
import { payrollContext } from '../payrollView'

const initialValuesForm = {
  targetGroup: '',
  certifiedTargetGroup: '',
  nameEmployee: '',
  startDate: null,
  endDate: null,
  stateStatus: null,
}

const PayrollFilter = () => {
  const style = useMemo(() => DialogFilterPayroll(), []);
  const payrollService = useMemo(() => new PayrollService(), []);
  const { snackbarUI } = useUI();
  let currentRef = useRef(null);
  const [initialValues, setInitialValues] = useState(initialValuesForm);
  const [groupsSelected, setGroupsSelected] = useState([]);
  const [targetGroups, setTargetGroups] = useState([]);
  const [certifiedtargetGroups, setCertifiedTargetGroups] = useState([]);

  const {
    getRecordsList,
    handleCloseOrOpenModalFilter,
    openModalFilter,
    setFilterModal,
    filterModal,
  } = useContext(payrollContext);

  const validationForm = Yup.object({
    targetGroup: Yup.string().notRequired().nullable(),
    startDate: Yup.date()
    .nullable()
    .notRequired()
    .typeError('Invalid date, "MM/dd/yyyy" format'),
    endDate: Yup.date()
    .nullable()
    .notRequired()
    .typeError('Invalid date, "MM/dd/yyyy" format'),
    nameEmployee: Yup.string().nullable().notRequired()
  });

  const formik = useFormik({
    initialValues:initialValues,
    onSubmit:(values) => {
      submit(values)
    },
    validationSchema: validationForm
  })

  //TODO: pending for clear the filter when the user select other tab
  const submit = () => {
    const DATA = {
      targetGroup: groupsSelected,
      certifiedTargetGroup: initialValues.certifiedTargetGroup ? initialValues.certifiedTargetGroup : null,
      StartDateFrom: initialValues.startDate ? moment(initialValues.startDate).format('MM/DD/YYYY') : null,
      StarDateTo: initialValues.endDate ? moment(initialValues.endDate).format('MM/DD/YYYY') : null,
      StateStatus: initialValues.stateStatus ? initialValues.stateStatus : null,
      EmployeeName: initialValues.nameEmployee ? initialValues.nameEmployee : null,
    };
    const params = {filters: {...filterModal, ...DATA}};
    getRecordsList(params);
    setFilterModal({...filterModal, ...DATA});
    handleCloseOrOpenModalFilter();
  }

  const handleChangeGroups = (event) => {
    const value = event.target.value
    setGroupsSelected(typeof value === 'string' ? value.split(',') : value,)
  }

  const handleChangeCertifiedGroup = (event) => {
  setInitialValues((prev) => ({
    ...prev,
    certifiedTargetGroup: event.target.value,
  }));
};
  
  const handleChangeStateStatus = (e) => {
    const check = e.target
    if(check.checked){
      setInitialValues((prev) => ({...prev, stateStatus: check.value}))
    }else{
      setInitialValues((prev) => ({...prev, stateStatus: null}))
    }
  }

  const handleChangeTypeText = (e) => {
    setInitialValues((prev) => ({...prev, [e.target.name]: e.target.value}))
  }

  const getList = () => {
    if(groupsSelected.length) return true
    return Object.values(initialValues).some(valor => valor !== null && valor !== undefined && valor !== '');
  }

  const handleCloseFilters = () => {
    setFilterModal({});
    formik.resetForm();
    setGroupsSelected([]);
    setInitialValues(initialValuesForm);
    handleCloseOrOpenModalFilter();
    const canGetList = getList();
    if(canGetList)getRecordsList({filters:{}});
  }
  
  const getTargetGroups = async () => {
    try {
      const response = await payrollService.targetGroups(false);
      setTargetGroups(response?.data?.data);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
    }
  }

    const getCertifiedTargetGroups = async () => {
    try {
      const response = await payrollService.targetGroups(true);
      setCertifiedTargetGroups(response?.data?.data);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
    }
  }

  useEffect(() => {
    if(!currentRef.current && openModalFilter){
      getTargetGroups();
      getCertifiedTargetGroups()
      currentRef.current = true;
    }
  }, [openModalFilter])

  return (
    <Dialog sx={style.dialog} open={openModalFilter}>
      <Box sx={style.body}>
        <Typography sx={style.title}>Filters</Typography>

        <form onSubmit={formik.handleSubmit}>
          <Box sx={style.form}>
              <Grid container spacing={0}>
                <Grid item xs={12} md={12} lg={12} sx={style.marginDown}>
                  <FormControl fullWidth>
                    <Typography sx={style.label}>
                      Target Group
                    </Typography>
                    <Select
                      multiple
                      size="small"
                      name='targetGroup'
                      value={groupsSelected}
                      onChange={handleChangeGroups}
                      //input={<OutlinedInput sx={style.fieldsInput}/>}
                      sx={style.fieldsInput}
                      renderValue={(selected) => {
                        if (selected.length === 0) return <em>Select</em>;
                        return selected?.length > 2 
                          ? (<div>{selected[0]}, <spam style={style.otherValuesForGroups} >{`+ ${selected?.length -1} More`}</spam></div>)
                          : selected?.join(', ')
                      }}
                      MenuProps={MenuItemProps}
                      margin="dense" 
                    >
                      {targetGroups?.map((group, index) => (
                        <MenuItem
                          key={group?.id}
                          value={group?.targetGroup}
                          sx={style.menuItem}
                        >
                          <Checkbox
                            //checked={groupsSelected.indexOf(group?.id) > -1}
                            checked={groupsSelected.indexOf(group?.targetGroup) > -1}
                            sx={style.checkBox}
                            color="primary"
                          />
                          <ListItemText sx={style.textSelect} primary={group?.targetGroup} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12} sx={style.marginDown}>
                  <FormControl fullWidth>
                    <Typography sx={style.label}>
                      Certified Target Group
                    </Typography>

                    <Select
                      size="small"
                      name="certifiedTargetGroup"
                      value={initialValues.certifiedTargetGroup || ""}
                      onChange={handleChangeCertifiedGroup}
                      sx={style.fieldsInput}
                      MenuProps={MenuItemProps}
                      margin="dense"
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) return <em></em>;
                        return selected;
                      }}
                    >
                      {certifiedtargetGroups?.map((group) => (
                        <MenuItem
                          key={group?.id}
                          value={group?.targetGroup}
                          sx={style.menuItem}
                        >
                          <ListItemText
                            sx={style.textSelect}
                            primary={group?.targetGroup}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <DateFilter
                  startDate={formik.values.startDate}
                  endDate={formik.values.endDate}
                  onChange={({ startDate, endDate }) => {
                    formik.setFieldValue('startDate', startDate);
                    formik.setFieldValue('endDate', endDate);
                    setInitialValues(prev => ({ ...prev, startDate, endDate }));
                  }}
                  errors={formik.errors}
                  touched={formik.touched}
                />
      
                <Grid item xs={12} md={12} lg={12} sx={{margin: '15px 0'}}>
                  <FormControl fullWidth>
                    <Typography sx={style.label}>
                      Employee Name
                    </Typography>
                    <TextField
                      id="nameEmployee" 
                      variant="outlined"
                      name='nameEmployee'
                      size="small"
                      sx={style.fieldsInput}
                      value={initialValues.nameEmployee}
                      onChange={(e)=> handleChangeTypeText(e)}
                      error={formik.touched.nameEmployee && Boolean(formik.errors.nameEmployee)}
                      helperText={formik.touched.nameEmployee && formik.errors.nameEmployee}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <Typography sx={style.label}> State Status</Typography>
                </Grid>

                <Grid item xs={12} md={12} lg={12} sx={{marginBottom: '10px'}}>
                  <FormGroup sx={style.formGroup} row>
                    {stateStatusList?.map((state) => (
                      <FormControlLabel
                        control={<Checkbox
                            sx={style.checkBox}
                            size="small"
                            value={state?.stateStatus}
                            onChange={handleChangeStateStatus}
                            checked={initialValues.stateStatus === state?.stateStatus}
                          />
                        }
                        label={convertNameStateStatus(state?.stateStatus)}
                        sx={style.labelCheckbox}
                        key={state?.id}
                      />
                    ))}
                  </FormGroup>
                </Grid>
              </Grid>
          </Box>
          <Box sx={style.divActions}>
            <Button
              onClick={handleCloseFilters}
              variant="contained"
              sx={style.buttonCancel}
              >
              Cancel
            </Button>
            <Button
              type='submit'
              variant="contained"
              sx={style.buttonApply}
              >
              Apply
            </Button>
          </Box>
        </form>
      </Box>
      
    </Dialog>
  )
}

export default PayrollFilter